module.exports = __webpack_public_path__ + "img/primary1.0a64031b.png";